module.exports = __webpack_public_path__ + "img/comeinto_detail@2x.e6909897.png";